function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.24 16.8192C189.212 13.1612 195.354 11 202 11C218.569 11 232 24.4315 232 41C232 57.5685 218.569 71 202 71C195.138 71 188.814 68.6963 183.76 64.82C188.928 58.0808 192 49.6491 192 40.5C192 31.6379 189.118 23.449 184.24 16.8192Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_52518_37067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 202,
  cy: 41,
  r: 30,
  fill: "#ECEFF0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.997 19.75L201.724 20.6796V47.6555L201.997 47.9285L214.493 40.5268L201.997 19.75Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.996 19.75L189.5 40.5268L201.996 47.9286V34.8353V19.75Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.997 52.0024L201.843 52.1903V61.7997L201.997 62.2498L214.5 44.6045L201.997 52.0024Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.996 62.2499V52.0024L189.5 44.6045L201.996 62.2499Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.996 47.9284L214.492 40.5269L201.996 34.8354V47.9284Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.5 40.5268L201.996 47.9285V34.8353L189.5 40.5268Z",
  fill: "#383838"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.76 16.8192C106.788 13.1612 100.646 11 94 11C77.4315 11 64 24.4315 64 41C64 57.5685 77.4315 71 94 71C100.862 71 107.186 68.6963 112.24 64.82C107.072 58.0808 104 49.6491 104 40.5C104 31.6379 106.882 23.449 111.76 16.8192Z",
  fill: "#D9D9D9"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_52518_37067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 41,
  r: 30,
  fill: "#063C4F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.585 45.6408C71.806 45.647 72.0278 45.6501 72.2504 45.6501C76.8269 45.6501 81.0966 44.3363 84.7028 42.0652C86.179 49.6637 92.8694 55.4001 100.899 55.4001C107.472 55.4001 113.146 51.5577 115.8 45.9969C116.005 45.8882 116.208 45.7752 116.409 45.6582C113.509 55.2868 104.573 62.3001 93.9995 62.3001C83.4193 62.3001 74.4792 55.2783 71.585 45.6408Z",
  fill: "url(#paint0_radial_52518_37067)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.585 45.6408C71.806 45.647 72.0278 45.6501 72.2504 45.6501C76.8269 45.6501 81.0966 44.3363 84.7028 42.0652C86.179 49.6637 92.8694 55.4001 100.899 55.4001C107.472 55.4001 113.146 51.5577 115.8 45.9969C116.005 45.8882 116.208 45.7752 116.409 45.6582C113.509 55.2868 104.573 62.3001 93.9995 62.3001C83.4193 62.3001 74.4792 55.2783 71.585 45.6408Z",
  fill: "#04171E",
  fillOpacity: 0.88
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.6973 46.0036C71.8811 46.0079 72.0655 46.01 72.2504 46.01C76.8546 46.01 81.1482 44.6803 84.7681 42.384C86.3672 49.8235 92.9821 55.4 100.9 55.4C107.472 55.4 113.146 51.5576 115.8 45.9968C116.005 45.8881 116.208 45.7751 116.409 45.6581C113.509 55.2867 104.573 62.3 93.9996 62.3C83.5527 62.3 74.7048 55.454 71.6973 46.0036Z",
  fill: "url(#paint1_radial_52518_37067)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.6973 46.0036C71.8811 46.0079 72.0655 46.01 72.2504 46.01C76.8546 46.01 81.1482 44.6803 84.7681 42.384C86.3672 49.8235 92.9821 55.4 100.9 55.4C107.472 55.4 113.146 51.5576 115.8 45.9968C116.005 45.8881 116.208 45.7751 116.409 45.6581C113.509 55.2867 104.573 62.3 93.9996 62.3C83.5527 62.3 74.7048 55.454 71.6973 46.0036Z",
  fill: "#04171E",
  fillOpacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.07 54.8684C101.743 57.6356 97.4657 59.2998 92.8 59.2998C84.0908 59.2998 76.736 53.5011 74.3857 45.5539C78.1535 45.213 81.6635 43.979 84.7023 42.0652C86.1786 49.6637 92.8689 55.4001 100.899 55.4001C102.34 55.4001 103.738 55.2154 105.07 54.8684Z",
  fill: "url(#paint2_linear_52518_37067)",
  fillOpacity: 0.64
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.2 38.9C113.2 49.5039 104.604 58.1 93.9998 58.1C83.3959 58.1 74.7998 49.5039 74.7998 38.9C74.7998 28.2961 83.3959 19.7 93.9998 19.7C104.604 19.7 113.2 28.2961 113.2 38.9Z",
  fill: "url(#paint3_radial_52518_37067)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.924 35.2947C111.924 42.7506 105.88 48.7947 98.4238 48.7947C90.968 48.7947 84.9238 42.7506 84.9238 35.2947C84.9238 27.8389 90.968 21.7947 98.4238 21.7947C105.88 21.7947 111.924 27.8389 111.924 35.2947Z",
  fill: "url(#paint4_radial_52518_37067)",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.2592 21.819C94.9581 21.8029 94.6548 21.7947 94.3497 21.7947C91.4774 21.7947 88.7739 22.5174 86.4111 23.7909C87.6748 23.5124 88.9878 23.3656 90.3351 23.3656C91.7084 23.3656 93.0461 23.5181 94.3321 23.8071L95.2592 21.819Z",
  fill: "url(#paint5_linear_52518_37067)",
  fillOpacity: 0.64
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.37 24.3929C103.429 26.8804 108.488 33.6086 108.488 41.5184C108.488 44.7703 107.633 47.8224 106.135 50.4623C109.205 47.4252 111.106 43.2102 111.106 38.5511C111.106 30.3555 105.222 23.5341 97.4483 22.0807L96.37 24.3929Z",
  fill: "url(#paint6_linear_52518_37067)",
  fillOpacity: 0.64
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.261 55.1316C101.293 57.0118 97.7736 58.1003 94.0002 58.1003C88.0201 58.1003 82.6785 55.3663 79.1572 51.0801C80.1279 51.258 81.1284 51.3509 82.1505 51.3509C89.5722 51.3509 95.8495 46.4508 97.9235 39.7094C98.6079 39.7696 99.3006 39.8003 100.001 39.8003C104.795 39.8003 109.254 38.3581 112.965 35.8839C113.12 36.8666 113.2 37.874 113.2 38.9003C113.2 39.5374 113.169 40.1671 113.109 40.7883C112.03 46.613 108.794 51.6807 104.261 55.1316Z",
  fill: "url(#paint7_linear_52518_37067)",
  fillOpacity: 0.64
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.5908 45.6579C74.4903 55.2869 83.4263 62.3006 94.0004 62.3006C106.874 62.3006 117.32 51.9046 117.4 39.0498C116.116 39.0417 114.856 38.9302 113.629 38.7231C110.744 39.9942 107.555 40.7 104.2 40.7C103.037 40.7 101.894 40.6151 100.776 40.4513C98.7046 47.1966 92.4254 52.1003 85.0009 52.1003C79.8236 52.1003 75.2032 49.7158 72.1781 45.9851C71.9799 45.8799 71.7841 45.7708 71.5908 45.6579Z",
  fill: "url(#paint8_linear_52518_37067)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.4 39.0702C113.958 41.061 109.962 42.2004 105.7 42.2004C104.888 42.2004 104.085 42.159 103.294 42.0782C101.813 49.6704 95.1258 55.4004 87.1001 55.4004C80.5281 55.4004 74.8534 51.5581 72.2001 45.9973C71.9944 45.8885 71.7913 45.7756 71.5908 45.6585C74.4906 55.2871 83.4263 62.3004 94.0001 62.3004C106.867 62.3004 117.308 51.9155 117.4 39.0702Z",
  fill: "url(#paint9_radial_52518_37067)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.694 39.9652C114.284 40.6319 112.798 41.162 111.251 41.5382C111.05 43.247 110.664 44.9605 110.081 46.6539C108.66 50.7813 106.241 54.2815 103.187 56.9777C108.41 54.4643 112.665 49.9454 114.701 44.0319C115.165 42.6853 115.493 41.3248 115.694 39.9652Z",
  fill: "url(#paint10_linear_52518_37067)",
  fillOpacity: 0.64
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.766 40.4916C100.793 40.4562 100.842 40.4496 100.876 40.4768C101.657 41.0965 102.502 41.643 103.406 42.1067C103.445 42.1266 103.461 42.1752 103.442 42.2152C103.422 42.2552 103.375 42.2715 103.337 42.2516C102.422 41.7832 101.57 41.231 100.781 40.605C100.746 40.5778 100.74 40.527 100.766 40.4916Z",
  fill: "url(#paint11_linear_52518_37067)"
}));

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 40.5,
  r: 40,
  fill: "#2775CA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M124.667 32.3331C119.834 45.1667 126.5 59.6667 139.5 64.3331C140 64.6667 140.5 65.3331 140.5 65.8331V68.1667C140.5 68.4999 140.5 68.6667 140.334 68.8331C140.167 69.4999 139.5 69.8331 138.834 69.4999C129.5 66.4999 122.334 59.3331 119.334 49.9999C114.334 34.1667 123 17.3331 138.834 12.3331C139 12.1667 139.334 12.1667 139.5 12.1667C140.167 12.3331 140.5 12.8331 140.5 13.4999V15.8331C140.5 16.6667 140.167 17.1667 139.5 17.4999C132.667 19.9999 127.167 25.3331 124.667 32.3331Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M155.667 12.9999C155.834 12.3331 156.5 11.9999 157.167 12.3331C166.334 15.3331 173.667 22.4999 176.667 31.9999C181.667 47.8331 173 64.6667 157.167 69.6667C157 69.8331 156.667 69.8331 156.5 69.8331C155.834 69.6667 155.5 69.1667 155.5 68.4999V66.1667C155.5 65.3331 155.834 64.8331 156.5 64.4999C163.334 61.9999 168.834 56.6667 171.334 49.6667C176.167 36.8331 169.5 22.3331 156.5 17.6667C156 17.3331 155.5 16.6667 155.5 15.9999V13.6667C155.5 13.3331 155.5 13.1667 155.667 12.9999Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M148.5 38.1669C155.5 39.0001 159 41.0001 159 46.8333C159 51.3333 155.667 54.8333 150.667 55.6669V59.6669C150.5 60.5001 150 61 149.334 61H146.834C146 60.8332 145.5 60.3333 145.5 59.6669V55.6669C140 54.8333 137.334 51.8333 136.667 47.6669V47.5001C136.667 46.8333 137.167 46.3333 137.834 46.3333H140.667C141.167 46.3333 141.667 46.6669 141.834 47.3333C142.334 49.8333 143.834 51.6669 148.167 51.6669C151.334 51.6669 153.667 49.8337 153.667 47.1669C153.667 44.5001 152.167 43.5001 147.5 42.6669C140.5 41.8333 137.167 39.6669 137.167 34.1669C137.167 30.0001 140.334 26.6669 145.334 26.0001V22.1669C145.5 21.3333 146 20.8333 146.667 20.8333H149.167C150 21.0001 150.5 21.5001 150.5 22.1669V26.1669C154.334 26.5001 157.334 29.3333 158 33.0001V33.1669C158 33.8333 157.5 34.3333 156.834 34.3333H154.167C153.667 34.3333 153.167 34.0001 153 33.5001C152.167 31.0001 150.5 30.0001 147.5 30.0001C144.167 30.0001 142.5 31.4997 142.5 33.8333C142.5 36.1669 143.5 37.5001 148.5 38.1669Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_52518_37067",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(116.409 57.3575) rotate(179.948) scale(169.904 493.676)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.104167,
  stopColor: "#24537E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.520341,
  stopColor: "#4FC1C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAFFF4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_52518_37067",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(116.409 57.3574) rotate(179.948) scale(169.904 493.676)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.104167,
  stopColor: "#24537E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.520341,
  stopColor: "#4FC1C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAFFF4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_52518_37067",
  x1: 104.496,
  y1: 62.5344,
  x2: 96.7764,
  y2: 22.3812,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#04171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#04171E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_52518_37067",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(79.9489 53.9109) rotate(-57.5402) scale(33.8223 490.103)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.104167,
  stopColor: "#3A78B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.520341,
  stopColor: "#4FC1C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8CF2FD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_52518_37067",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(111.85 21.8) rotate(144.267) scale(33.2616 33.0255)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.216485,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.906332,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_52518_37067",
  x1: 106.15,
  y1: 29.3,
  x2: 86.3504,
  y2: 37.925,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732381,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_52518_37067",
  x1: 106.15,
  y1: 29.3,
  x2: 86.3504,
  y2: 37.925,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732381,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_52518_37067",
  x1: 142.902,
  y1: -11.7264,
  x2: 61.9219,
  y2: 55.7416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#04171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#04171E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_52518_37067",
  x1: 108.85,
  y1: 41.975,
  x2: 78.475,
  y2: 52.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0E6585"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#04171E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_52518_37067",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(77.7333 59.7662) rotate(-38.5632) scale(27.6946 431.949)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.104167,
  stopColor: "#3A78B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.520341,
  stopColor: "#4FC1C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8CF2FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_52518_37067",
  x1: 115.75,
  y1: 39.95,
  x2: 104.069,
  y2: 57.6562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.64
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_52518_37067",
  x1: 103.434,
  y1: 42.1748,
  x2: 99.6368,
  y2: 39.8273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CF2FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8CF2FD",
  stopOpacity: 0
})));

function SvgTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 81,
    viewBox: "0 0 296 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52518_37067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 11,
    width: 49,
    height: 60
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52518_37067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 11,
    width: 49,
    height: 60
  }, _ref4), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/Tokens.d135da37a6aece5629ead66b49b25db3.svg";
export { ForwardRef as ReactComponent };